import { cn } from '@dialogueconsulting/sked-ui/lib/utils'
import { forwardRef } from 'react'

import type { ConversationHeaderProps } from './types'

// forwardRef: Conversation spreads react-collapsed's getToggleProps() (which
// carries a ref) onto this header on mobile; forwarding it to the toggle div
// gives react-collapsed a valid ref and clears the "function components cannot
// be given refs" warning.
const ConversationHeader = forwardRef<HTMLDivElement, ConversationHeaderProps>(
  (
    {
      isExpanded,
      isMobile,
      isReadOnly,
      hasMessages,
      isConversationsEnabled,
      onToggle,
    },
    ref
  ) => {
    if (isMobile && !isReadOnly) {
      return (
        <div
          ref={ref}
          onClick={onToggle}
          className="flex items-center justify-between"
        >
          <h4 className="ml-[10px] text-base font-bold text-neutral-800">
            Conversation
          </h4>
          <i
            aria-hidden="true"
            className={cn(
              'fa-solid mr-[10px] text-[24px] text-neutral-800',
              isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'
            )}
          />
        </div>
      )
    }

    if (hasMessages && isConversationsEnabled) {
      return (
        <h4 className="text-base font-bold text-neutral-800">Conversation</h4>
      )
    }

    return null
  }
)

ConversationHeader.displayName = 'ConversationHeader'

export default ConversationHeader
